/**
 * File: src/validation/ant-clash-config-schema.js
 * Mô tả: Kiểm tra tính hợp lệ (Validation Schema) cho dữ liệu cấu hình Ant Clash trước khi lưu.
 * Liên quan: src/services/admin-config-service.js, src/components/admin-config-editor.js
 */

/**
 * Kiểm tra xem object config có tuân thủ cấu trúc hợp lệ của Ant Clash không
 * @param {Object} config 
 * @returns {{ valid: boolean, errors: string[] }}
 */
export const validateAntClashConfig = (config) => {
  const errors = [];

  if (!config || typeof config !== 'object') {
    return { valid: false, errors: ['Cấu hình phải là một đối tượng JSON hợp lệ.'] };
  }

  // 1. Kiểm tra testing_profile
  if (!config.testing_profile) {
    errors.push('Thiếu khối "testing_profile".');
  } else {
    if (typeof config.testing_profile.enabled !== 'boolean') {
      errors.push('Trường "testing_profile.enabled" phải là kiểu boolean.');
    }
  }

  // 2. Kiểm tra unit_progression
  if (!config.unit_progression) {
    errors.push('Thiếu khối "unit_progression".');
  } else {
    const up = config.unit_progression;
    if (typeof up.worker_move_speed !== 'number' || up.worker_move_speed <= 0) {
      errors.push('"unit_progression.worker_move_speed" phải là số dương.');
    }
    if (!Array.isArray(up.units) || up.units.length === 0) {
      errors.push('"unit_progression.units" phải là mảng chứa danh sách các loại kiến.');
    } else {
      up.units.forEach((u, i) => {
        if (!u.id || typeof u.damage !== 'number' || typeof u.hp !== 'number') {
          errors.push(`Kiến tại chỉ số ${i} (ID: ${u.id || 'N/A'}) có dữ liệu không hợp lệ.`);
        }
      });
    }
  }

  // 3. Kiểm tra economy
  if (!config.economy) {
    errors.push('Thiếu khối "economy".');
  } else {
    if (typeof config.economy.starting_currency !== 'number' || config.economy.starting_currency < 0) {
      errors.push('"economy.starting_currency" phải là số không âm.');
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};
